import { Avatar } from '@percent/lemonade'
import { createShortLink } from '@percent/utility'
import styled from 'styled-components'
import { OrganizerInfoProps } from './organizer-info.types'

const StyledOrganizerInfoWrapper = styled.div<{ topBorder: boolean }>`
  ${({ theme, topBorder }) => `
      display: flex;
      flex-flow: row;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: nowrap;
      margin-top: ${theme.sizes.m};
      margin-bottom: ${theme.sizes.m};
      ${
        topBorder
          ? `padding-top: ${theme.sizes.m}; border-top: 1px solid ${theme.colors.gray80};`
          : ''
      }
    `}
`

const StyledOrganizerAvatarWrapper = styled.div`
  display: flex;
`

const StyledOrganizerInfoDetails = styled.div`
  ${({ theme }) => `
      color: ${theme.colors.gray300};
      font-size: ${theme.fontSizes.bodySmall};
      font-weight: ${theme.fontWeights.regular};
      line-height: ${theme.fontSizes.body};
      margin-left: 10px;

      p {
        margin: 0 0 8px 0;
      }

      a {
        color: ${theme.colors.gray600};
        text-decoration: underline;
        text-decoration-color: ${theme.colors.gray600};
      }
    `}
`

export function OrganizerInfo({
  logo,
  name,
  website,
  topBorder = false,
  translations,
  badge,
  badgeTooltip,
}: Readonly<OrganizerInfoProps>) {
  return (
    <StyledOrganizerInfoWrapper
      topBorder={topBorder}
      data-testid="organizer-info"
    >
      <StyledOrganizerAvatarWrapper>
        <Avatar
          image={logo}
          alt={name}
          shape="oval"
          border
          badge={badge || undefined}
          badgeTooltip={badgeTooltip || undefined}
        />
      </StyledOrganizerAvatarWrapper>
      <StyledOrganizerInfoDetails>
        <p>{translations.description}</p>
        {website && (
          <a href={website} target="_blank" rel="noopener noreferrer">
            {createShortLink(website)}
          </a>
        )}
      </StyledOrganizerInfoDetails>
    </StyledOrganizerInfoWrapper>
  )
}
